import React, { useState } from 'react';
import PropTypes from 'prop-types';

// DS
import {
  Col, Row, VertInput, VertSelect,
} from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Forms/FormsDeliveryAddressStyles.less';

// UTILS

// MOCK
const listUF = [
  { value: 'AC', label: 'AC', availability: true },
  { value: 'AL', label: 'AL', availability: true },
  { value: 'AP', label: 'AP', availability: true },
  { value: 'AM', label: 'AM', availability: true },
  { value: 'BA', label: 'BA', availability: true },
  { value: 'CE', label: 'CE', availability: true },
  { value: 'DF', label: 'DF', availability: true },
  { value: 'ES', label: 'ES', availability: true },
  { value: 'GO', label: 'GO', availability: true },
  { value: 'MA', label: 'MA', availability: true },
  { value: 'MT', label: 'MT', availability: true },
  { value: 'MS', label: 'MS', availability: true },
  { value: 'MG', label: 'MG', availability: true },
  { value: 'PA', label: 'PA', availability: true },
  { value: 'PB', label: 'PB', availability: true },
  { value: 'PR', label: 'PR', availability: true },
  { value: 'PE', label: 'PE', availability: true },
  { value: 'PI', label: 'PI', availability: true },
  { value: 'RJ', label: 'RJ', availability: true },
  { value: 'RN', label: 'RN', availability: true },
  { value: 'RS', label: 'RS', availability: true },
  { value: 'RO', label: 'RO', availability: true },
  { value: 'RR', label: 'RR', availability: true },
  { value: 'SC', label: 'SC', availability: true },
  { value: 'SP', label: 'SP', availability: true },
  { value: 'SE', label: 'SE', availability: true },
  { value: 'TO', label: 'TO', availability: true },
];

// MODAL NEW DELIVERY ADDRESS COMPONENT
const FormsDeliveryAddress = ({ ...props }) => {
  const { data, onChange, isValid } = props;
  const [form, setForm] = useState({ ...data });

  const hasValid = () => {
    console.log(form);
    return (
      form.contact.length > 0
      && form.name.length > 0
      && form.street.length > 0
      && form.bourgh.length > 0
      && form.city.length > 0
      && form.state.length > 0
      && form.uf.length > 0
      && form.cep.length > 0
      && form.complement.length > 0
      && form.reference.length > 0
    );
  };

  const handleChange = (target, value) => {
    console.log(form, target, value);
    setForm({ ...form, [target]: value });
    onChange({ target, value });
    isValid(hasValid);
  };

  const handleMaskChange = (target, value) => {
    setForm({ ...form, [target]: value });
    const newValue = value.replace('-', '');
    onChange({ target, newValue });
  };

  return (
    <Col className="modal-new-delivery-address-form">
      <Row>
        <VertInput
          value={form.contact}
          onChange={({ target }) => handleMaskChange('contact', target.value)}
          placeholder="Contato"
          label="Contato"
          mask="(00) 00000-0000"
        />
        <VertInput
          value={form.name}
          onChange={({ target }) => handleChange('name', target.value)}
          placeholder="Nome Completo"
          label="Nome Completo"
        />
      </Row>
      <Row>
        <VertInput
          value={form.cep}
          onChange={({ target }) => handleMaskChange('cep', target.value)}
          placeholder="CEP"
          mask="00000-000"
        />
        <VertInput
          value={form.bourgh}
          onChange={({ target }) => handleChange('bourgh', target.value)}
          placeholder="Bairro"
        />
      </Row>
      <Row>
        <VertInput
          value={form.street}
          onChange={({ target }) => handleChange('street', target.value)}
          placeholder="Endereço"
        />
      </Row>
      <Row>
        <VertInput
          value={form.number}
          onChange={({ target }) => handleChange('number', target.value)}
          placeholder="Número"
        />
        <VertInput
          value={form.complement}
          onChange={({ target }) => handleChange('complement', target.value)}
          placeholder="Complemento"
        />
      </Row>

      <Row>
        <VertInput
          value={form.reference}
          onChange={({ target }) => handleChange('reference', target.value)}
          size="large"
          placeholder="Ponto De Referência"
        />
      </Row>
      <Row>
        <VertInput
          value={form.city}
          size="default"
          onChange={({ target }) => handleChange('city', target.value)}
          placeholder="Cidade"
        />
        <VertSelect
          items={listUF}
          showSearch
          placeholder="UF"
          template="marketplace"
          onChange={(value) => handleChange('uf', value)}
        />
      </Row>
    </Col>
  );
};

FormsDeliveryAddress.propTypes = {
  data: PropTypes.shape({
    contact: PropTypes.string,
    name: PropTypes.string,
    street: PropTypes.string,
    number: PropTypes.number,
    bourgh: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    uf: PropTypes.string,
    cep: PropTypes.string,
    complement: PropTypes.string,
    reference: PropTypes.string,
  }),
  onChange: PropTypes.func,
  isValid: PropTypes.func,
};


export default FormsDeliveryAddress;
